/* eslint-disable react/display-name */
import React, { CSSProperties, forwardRef } from "react";
import classNames from "classnames";

export interface ISpinnerProps {
  primary?: boolean;
  size?: SpinnerSize;
  style?: CSSProperties;
  className?: string;
  message?: string;
}

export enum SpinnerSize {
  Small = 16,
  Medium = 32,
  Large = 64,
}

const Spinner = forwardRef<SVGSVGElement, ISpinnerProps>(
  ({ size = SpinnerSize.Medium, style, className, primary, message }, ref) => {
    const strokeWidth = getStrokeWidth(size);
    const radius = size / 2;
    const offsetRadius = radius - strokeWidth / 2;
    const circumference = size * Math.PI;

    return (
      <div className={classNames("spinner", className, { "spinner--primary": primary })} style={style}>
        {message && <div className="spinner__message">{message}</div>}
        <svg
          className="spinner__element"
          fill="none"
          strokeWidth={strokeWidth}
          width={size}
          height={size}
          strokeLinecap="round"
          viewBox={`${radius} ${radius} ${size} ${size}`}
          ref={ref}
        >
          <circle className="spinner__background" cx={size} cy={size} r={offsetRadius} strokeOpacity={0.2} />
          <circle
            className="spinner__path"
            cx={size}
            cy={size}
            r={offsetRadius}
            strokeDasharray={`${circumference / 4} ${circumference}`}
            strokeDashoffset={circumference}
          />
        </svg>
      </div>
    );
  },
);

function getStrokeWidth(size: SpinnerSize): number {
  switch (size) {
    case SpinnerSize.Small:
      return 3;
    case SpinnerSize.Medium:
      return 4;
    case SpinnerSize.Large:
      return 5;
    default:
      return 3;
  }
}

export default Spinner;
